import { ICardsOfferProps } from '../components/partner-pages/page-sections/rewards-section/exciting_offers/cards-offers';

export const heroValuePartner = {
  heading: 'Taxes are simple with us',
  bulletPoint: [
    'No manual data entry',
    '100% pre-fill in a click',
    'Maximum tax savings',
  ],
  description: '',
  btnText: 'File Now',
  btnLink: `/filing?&utm_ref=itr_partner_page`,
  videoSource:
    'https://assets1.cleartax-cdn.com/cleartax/images/1655805670_filingwalkthrough_video.mp4',
  videoSourceWebm:
    'https://assets1.cleartax-cdn.com/cleartax/images/1661426795_1655805670_filingwalkthrough_video.webm',
  videoPoster:
    'https://assets1.cleartax-cdn.com/cleartax/images/1683617289_group18142181061.png',
};

export const SecureComponentData = {
  hero: {
    heading: 'Your data is secure, privacy is assured',
    headingclass: 'text-s-48 sm:text-s-32 sm:mb-2.5',
    description:
      'We were awarded a GSP license after rigorous scrutiny of our technological and financial capabilities to serve our clients.',
    imageSource:
      'https://assets1.cleartax-cdn.com/finfo/wg-utils/retool/cc636cd5-8f5f-4836-83d2-d2545c88f0ca.png',
    mediaHeight: 500,
    mediaWidth: 400,
  },
  cards: [
    {
      icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1606110290_encryption.svg',
      heading: 'Data Encryption',
      description:
        'We are 128-bit SSI certified and PCI complaint which means your data reaches our servers safely.',
    },
    {
      icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1606110503_home_data_storage.svg',
      heading: 'Safe Storage',
      description:
        'We use ISO 27001 certified data centers, which are quarterly VAPT tested and externally audited.',
    },
    {
      icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1606308817_privacyaware.svg',
      heading: '100% Privacy Control',
      description:
        'We do not share our or your clients’ data with unaffiliated third parties for their own purposes.',
    },
  ],
};
export const guidesCardsStocks = [
  {
    label: 'Capital Gains Tax in India',
    description:
      'A comprehensive guide on capital gains tax in India and how you can compute',
    link: 'https://cleartax.in/s/capital-gains-income',
  },
  {
    label: 'How to file ITR-2?',
    description: 'All you need to know about ITR-2 filing',
    link: 'https://cleartax.in/s/itr2',
  },
  {
    label: 'LTCG tax on equity funds',
    description: 'LTCG tax on equity funds with example',
    link: 'https://cleartax.in/s/equity-funds-ltcg-taxation',
  },
  {
    label: 'Capital gains exemption',
    description: 'List of exemptions under capital gains',
    link: 'https://cleartax.in/s/capital-gain-exemption',
  },
  {
    label: 'Taxation of income earned from selling shares',
    description: 'How to calculate tax on income from sale of shares?',
    link: 'https://cleartax.in/s/taxation-on-income-earned-from-selling-shares',
  },
  {
    label: 'Old vs new tax regime',
    description:
      'A guide to switching to the new or remaining in the old tax regime',
    link: 'https://cleartax.in/s/old-tax-regime-vs-new-tax-regime',
  },
  {
    label: 'Income tax calculator',
    description: 'Calculate your income tax for FY 2022-23 or previous years',
    link: 'https://cleartax.in/paytax/TaxCalculator',
  },
  {
    label: 'Crypto tax calculator',
    description: 'Calculate tax on your cryptocurrency gains',
    link: 'https://cleartax.in/s/crypto-tax-calculator',
  },
];
export const guideCardsCrypto = [
  {
    label: 'Crypto Tax Filing',
    description:
      'Best Crypto tax solution in India for filing and returning Crypto taxes',
    link: 'https://cleartax.in/s/cryptotax',
  },
  {
    label: 'Crypto Taxes India',
    description: 'Guide to Cryptocurrency taxes in India',
    link: 'https://cleartax.in/s/cryptocurrency-taxation-guide',
  },
  {
    label: 'Tips To Save Crypto Taxes',
    description: 'How to save Crypto tax in India?',
    link: 'https://cleartax.in/s/tips-to-save-crypto-taxes',
  },
  {
    label: 'Non Fungible Token (NFT)',
    description: 'What is NFT and how does it work?',
    link: 'https://cleartax.in/s/nft-non-fungible-token',
  },
  {
    label: 'Crypto Tax Calculator',
    description: 'Calculate tax on your Cryptocurrency gains',
    link: 'https://cleartax.in/s/crypto-tax-calculator',
  },
  {
    label: 'Bitcoin Tax Calculator',
    description:
      'Calculate the income tax liability on the transfer of bitcoin',
    link: 'https://cleartax.in/s/bitcoin-tax-calculator',
  },
  {
    label: 'NFT Tax Calculator',
    description: 'Calculate tax on non-fungible token gains',
    link: 'https://cleartax.in/s/nft-tax-calculator',
  },
  {
    label: 'Income Tax Calculator',
    description: 'Calculate your Income Tax for FY 2022-23 or previous years',
    link: 'https://cleartax.in/paytax/TaxCalculator',
  },
];

export const GuidesAndLinksDataITR = {
  heading: 'Guides and useful links to help you Efile taxes',
  cards: [
    {
      label: 'Income Tax Calculator',
      description:
        'Calculate your Income Tax for FY 2024-25 or previous years.',
      link: 'https://cleartax.in/paytax/taxcalculator',
    },
    {
      label: 'Income Tax Slabs',
      description:
        'Income Tax Slabs and Rates applicable for FY 2025-26 and FY 2024-25 under New and Old Tax Regime.',
      link: 'https://cleartax.in/s/income-tax-slabs',
    },
    {
      label: 'Old vs New Tax Regime',
      description:
        'Know the difference between Old tax regime and New tax regime. Key deductions allowed under the new tax regime and the better regime for you.',
      link: 'https://cleartax.in/s/old-tax-regime-vs-new-tax-regime',
    },
    {
      label: 'Form 26AS',
      description:
        'Form 26AS is a consolidated Annual Information Statement providing details of Tax Deducted at Source (TDS) and Tax Collected at Source (TCS) during a particular financial year.',
      link: 'https://cleartax.in/s/view-form-26as-tax-credit-statement',
    },
    {
      label: 'New Tax Regime',
      description:
        'The New Tax Regime under Section 115BAC offers enhanced tax slabs and rates but little deductions. Know if the new tax regime is the right tax regime for you to file your ITR.',
      link: 'https://cleartax.in/s/section-115bac-features-new-tax-regime-benefits',
    },
    {
      label: 'Type of ITR Forms',
      description:
        'Choosing a particular ITR form depends on the income source of the taxpayer. Confused between which ITR to file? We have got it all covered for you.',
      link: 'https://cleartax.in/s/which-itr-to-file',
    },
    {
      label: 'Late Date to File ITR',
      description:
        'The last date to file ITR for FY 2024-25 has been extended to 15th September 2025 for taxpayers not required to comply with tax audit.',
      link: 'https://cleartax.in/s/due-date-tax-filing',
    },
    {
      label: 'What Is Form 16',
      description:
        'Form 16 is a certificate issued by an employer to a salaried employee, detailing the Tax Deducted at Source (TDS) on salary income during a financial year.',
      link: 'https://cleartax.in/s/what-is-form-16',
    },
    {
      label: 'Section 87A Rebate',
      description:
        'Taxpayers with total taxable income below a certain limit enjoy zero tax liability as they are eligible for a rebate. Are you one of them?',
      link: 'https://cleartax.in/s/income-tax-rebate-us-87a',
    },
    {
      label: 'Capital Gains Tax in India',
      description:
        'Capital gains tax depends on the type of asset and the period of holding. Tax is calculated depending on the time for which assets are held.',
      link: 'https://cleartax.in/s/capital-gains-income',
    },
    {
      label: 'Income Tax For NRIs',
      description:
        'NRIs are not subject to tax in India. But if they earn income in India, they will have to pay tax on it.',
      link: 'https://cleartax.in/s/income-tax-for-nri',
    },
    {
      label: 'Leave Travel Allowance',
      description:
        'Leave Travel Allowance is provided by the employer to cover travel expenses incurred while on leave. It is meant for domestic travel within India and is exempt if certain conditions are met.',
      link: 'https://cleartax.in/s/lta-leave-travel-allowance',
    },
    {
      label: 'How to File ITR?',
      description:
        'Taxpayers can file ITR through the e-Filing portal. Filing ITR is a hassle-free and easy process if you are filing your ITR with ClearTax.',
      link: 'https://cleartax.in/s/how-to-efile-itr',
    },
    {
      label: 'Form 10IEA',
      description:
        'Form 10IEA is a form which taxpayers with business or professional income have to file to opt out of the new tax regime and file ITR under the old tax regime.',
      link: 'https://cleartax.in/s/form-10iea',
    },
    {
      label: 'Income Tax Refund',
      description:
        'If the TDS, TCS, or Advance Tax paid by you is more than your actual tax liability, then you are eligible for an Income Tax Refund.',
      link: 'https://cleartax.in/s/income-tax-refund',
    },
    {
      label: 'Section 10',
      description:
        'Section 10 of the Income Tax Act, 1961, lists various types of incomes that are exempt from tax and help reduce taxable income and tax liability.',
      link: 'https://cleartax.in/s/section-10-of-income-tax-act',
    },
  ],
};

export const CalculatorTabData = {
  heading: 'Calculators and useful links',
  cards: [
    {
      label: 'Tax Calculator',
      description: `Quickly calculate your income tax liability with our easy-to-use tool. Get accurate results and simplify your tax planning today!`,
      link: 'https://cleartax.in/paytax/taxcalculator',
    },
    {
      label: 'HRA Calculator',
      description: `Calculate your House Rent Allowance exemption quickly and accurately. Simplify tax planning with our easy-to-use online HRA calculator.`,
      link: 'https://cleartax.in/paytax/hracalculator',
    },
    {
      label: 'SIP Calculator',
      description: `Estimate your SIP returns effortlessly with our easy-to-use calculator. Plan your investments and achieve your financial goals with clarity.`,
      link: 'https://cleartax.in/s/sip-calculator',
    },
    {
      label: 'PPF Calculator',
      description: `Effortlessly calculate your Public Provident Fund returns with our user-friendly tool. Plan your investments and secure your financial future.`,
      link: 'https://cleartax.in/s/ppf-calculator',
    },
    {
      label: 'Home Loan EMI',
      description: `Calculate your monthly EMI instantly and plan your finances with ease using our simple and accurate home loan EMI calculator.`,
      link: 'https://cleartax.in/s/home-loan-emi-calculator',
    },
    {
      label: 'Interest Calculator',
      description: `Easily compute simple and compound interest with our user-friendly calculator. Perfect for loans, investments, and savings growth estimates.`,
      link: 'https://cleartax.in/s/simple-compound-interest-calculator',
    },
    {
      label: 'Smart Tax Planning',
      description: `Optimize your finances with expert tax-saving strategies, effortless compliance, and personalized solutions tailored to your unique financial goals.`,
      link: 'https://cleartax.in/planning',
    },
    {
      label: 'Retirement Planner',
      description: `Secure your future with ease. Use our calculator to estimate savings and plan a stress-free, financially stable retirement.`,
      link: 'https://cleartax.in/s/retirement-planning-calculator',
    },
  ],
};

export const GuidesAndLinksData = {
  heading: 'Guides and Tools',
  cards: [
    {
      label: 'Income Tax e-Filing for FY 2025-26',
      description: `File your ITR hassle-free entirely by yourself in under 3 minutes. We've made e-filing incredibly easy for you.`,
      link: '/income-tax-efiling ',
    },
    {
      label: 'Income Tax Slabs for FY 2025-26',
      description:
        'Income tax slab rate for Old and New Tax regime – FY 2025-26 (AY 2026-27).',
      link: '/s/income-tax-slabs',
    },
    {
      label: 'Income Tax Calculator',
      description:
        'Calculate your Income Tax for FY 2025-26 or previous years.',
      link: '/paytax/TaxCalculator',
    },
    {
      label: 'Section 80 Deductions',
      description:
        'Expenses and investments under Section 80 help to reduce taxable income and lower taxes.',
      link: '/s/80c-80-deductions',
    },
    {
      label: 'Old vs New Tax Regime',
      description:
        'Decision making guide to switch to the new or remain in the old tax regime.',
      link: '/s/old-tax-regime-vs-new-tax-regime',
    },
    {
      label: 'Check Aadhar PAN Card Link Status',
      description:
        'Step-by-step and comprehensive guide to check Aadhaar card PAN card link status online.',
      link: '/s/how-to-check-aadhar-card-pan-card-link-status',
    },
    {
      label: 'ITR Filing Last Date for FY 2025-26',
      description:
        'Check the last date to file Income Tax Return for FY 2025-26 (AY 2026-27).',
      link: '/s/due-date-tax-filing',
    },
    {
      label: 'Capital Gains Tax in India',
      description: 'Comprehensive guide on Capital Gains tax in India.',
      link: '/s/capital-gains-income',
    },
  ],
};

export const excitingOffersData: ICardsOfferProps[] = [
  {
    logo: 'https://assets1.cleartax-cdn.com/cleartax/images/1658779714_62989816e7f6f6df7399f837_simpllogo500xx50001.png',
    description: 'Cashback up to ₹150 on paying with Simpl',
    color: 'cyan',
    discount: '15%',
  },
  {
    logo: 'https://assets1.cleartax-cdn.com/cleartax/images/1658779747_6290cb22fbfb8433ccbdf4aa_olamoneylogo4x.png',
    description: 'Cashback up to ₹60 on paying with Ola Money',
    color: 'green',
    discount: '15%',
  },
  {
    logo: 'https://assets1.cleartax-cdn.com/cleartax/images/1658779785_6290cb9b71943f642558e6ab_mobikwiklogoicon1.png',
    description: 'Supercash upto ₹100 on paying with Mobikwik',
    color: 'blue',
    discount: '10%',
  },
];

export const partnerFAQs = [
  {
    header: 'What is e Filing of income tax return (ITR)?',
    content: (
      <div>
        <p>
          Individuals, except senior citizens, have to mandatorily file the ITR
          through the online mode which is also known as electronic filing, i.e.
          e-filing of the income tax return. <br /> An income tax return is a
          form that a person is required to submit to the Income Tax Department.
          It contains information related to individual&apos;s income and taxes
          paid, starting from 1st April to 31st March of the financial year.
          There are seven ITR forms prescribed by the Income Tax Department
          according to the amount of income, income source and the category to
          which the taxpayer belongs.
        </p>
        <p className="pt-10">
          E-filing of the income tax return can be done through Clear’s e-filing
          utility in a smooth and simple manner. Clear is a
          government-authorised portal to carry out e-filing of the returns and
          hence 100% authenticity and security is maintained.
        </p>
      </div>
    ),
  },
  {
    header: 'How can you file an income tax return in India?',
    content: (
      <div>
        <p>
          You can file your income tax returns online, either on the income tax
          department&apos;s website or with us at www.cleartax.in. Income tax
          filing or e-filing is made easy on Cleartax. You can e-file your
          returns in just 3 minutes without any manual effort.
        </p>
        <p className="mt-10">
          Also, note that the due date to e-file your income tax returns for the
          assessment year 2025-26 is on or before 15th September 2025.
        </p>
      </div>
    ),
  },
  {
    header: 'My company deducts TDS. Do I still have to file my ITR?',
    content: (
      <p>
        Yes, deducting TDS and filing a tax return are two separate legal
        compliances. Income tax should be paid on your taxable income as per the
        provisions of the Income Tax Act. Whereas, you file a tax return to show
        that you&apos;ve paid all the tax you needed to pay. The income tax
        return is also a very useful document when it comes to applying for a
        loan or visa.
      </p>
    ),
  },
  {
    header: 'Which income tax return should I select for e Filing?',
    content: (
      <p>
        There are seven forms - ITR 1, 2, 3, 4, 5, 6 and 7 notified by the
        government for different categories of taxpayers. ITR-1 to ITR-4 applies
        to individuals and HUFs. They can choose the appropriate ITR form based
        on the income earned and source of income. ITR-5 applies to partnership
        firms, LLPs, AOP (Association of Persons), BoI (Body of Individuals),
        Artificial Juridical Person (AJP), Estate of deceased, Estate of
        insolvent, Business trust and investment fund. All the companies should
        file ITR-6. It does not apply to companies claiming exemption from
        income from property held for charitable or religious purposes. Such
        companies should file ITR-7. If you are e-filing with ClearTax, we
        automatically decide on the correct income tax return form.
      </p>
    ),
  },
  {
    header: 'How do I pay tax to the government?',
    content: (
      <div>
        <p>
          You can pay tax to the government directly on the Income Tax
          Department website using your net-banking account or debit card using
          challan 280.
        </p>
        <p className="pt-10">
          The payment types for below taxes are as follows:
        </p>
        <ul className="list-disc pl-6 pt-10">
          <li>
            <b>Advance Tax-</b> (100) Advance Tax
          </li>
          <li>
            <b>Self assessment tax-</b> (300) Self Assessment Tax
          </li>
          <li>
            <b>Regular assessment-</b> (400) Tax on Regular Assessment Tax
          </li>
        </ul>
      </div>
    ),
  },
  {
    header:
      "I am a salaried individual and don't have a Form 16. How can I file my tax return?",
    content: (
      <p>
        You can still file your tax return on ClearTax without a Form 16.
        You&apos;re just going to need your payslips. Follow the instructions on
        this <a href="https://cleartax.in/s/efile-without-form-16">guide</a> to
        e-file without Form 16.
      </p>
    ),
  },
  {
    header: 'What is ITR-V?',
    content: (
      <p>
        ITR-V is a 1-page document that you receive after e-filing your income
        tax return and where e-verification is pending. You can verify your
        income tax return through offline or online mode. There are various
        methods of online verification. However, to verify your return offline,
        you must print, sign and send the ITR-V to the Income Tax Department
        within 120 days from e-filing your tax return.
      </p>
    ),
  },
  {
    header:
      'Is it necessary to attach any documents along with the return of income?',
    content: (
      <p>
        ITR return forms are attachment-less forms and, hence, the taxpayer is
        not required to attach any document (like proof of investment, TDS
        certificates, etc.) along with the return of income (whether filed
        manually or filed electronically). However, these documents should be
        retained by the taxpayer and should be produced before the tax
        authorities when demanded in situations like assessment, inquiry, etc.
      </p>
    ),
  },
  {
    header: 'Can I file ITR-1 with exempt agricultural income?',
    content: (
      <p>
        You can file ITR 1 if the agricultural income is up to Rs 5,000. For
        agricultural income exceeding Rs 5,000, you have to file ITR 2. To know
        about ITR 2 .Click <a href="https://cleartax.in/s/itr2">here</a>.
      </p>
    ),
  },
  {
    header: 'If I have paid excess tax, how will it be refunded to me?',
    content: (
      <p>
        You can claim a refund of the excess tax paid by filing your Income-tax
        return. It will be refunded to you by crediting it to your bank account
        through ECS transfer. It is important to pre-validate your bank account
        details before filing your income tax return.
      </p>
    ),
  },
];
